import User from 'assets/images/user.png';
import styles from './index.module.scss';

const Avatar = ({ children, className, src, onError, ...props }) => (
  <img
    className={[styles.avatar, className].filter(Boolean).join(' ')}
    src={src || User}
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = User;
      onError?.(e);
    }}
    {...props}
  >
    {children}
  </img>
);

export default Avatar;
